module.exports = __webpack_public_path__ + "img/a41f0a6504130392e8bbe96a5af965d7.png";